import { LoadingState } from "../../Common/Models/LoadingState";
import { ResponseError } from "../../Common/Models/ResponseError";
import { TopicSubscriptionActionType } from "../Actions/TopicSubscriptionActions";

export interface TopicSubscriptionsActionBase {
  type: TopicSubscriptionActionType;
}

export interface TopicSubscriptionAction<Payload> extends TopicSubscriptionsActionBase {
  payload: Payload;
}

export interface TopicSubscriptionsState {
  subscriptionStates: Record<string, TopicSubscriptionState>;
}

export interface TopicSubscriptionState {
  topicName?: string;
  isSubscribed?: boolean;
  loadingState: LoadingState;
  loadingError?: ResponseError;
}

const initialState: TopicSubscriptionsState = {
  subscriptionStates: {} as Record<string, TopicSubscriptionState>
};

const updateObject = (oldObject: any, newValues: any) => ({ ...oldObject, ...newValues });

function createLoadingState(errored: boolean, isLoading: boolean, isLoaded: boolean): LoadingState {
  return {
    errored,
    isLoaded,
    isLoading
  };
}

function updateSubscriptionState(
  topicCode: string,
  oldState: TopicSubscriptionsState,
  newValues: any
) {
  const newStates: Record<string, TopicSubscriptionState> = updateObject(
    oldState.subscriptionStates,
    {}
  );

  let newState: TopicSubscriptionState;

  if (!newStates[topicCode]) {
    newState = updateObject(
      {
        loadingState: createLoadingState(false, false, false)
      },
      newValues
    );
  } else {
    newState = updateObject(newStates[topicCode], newValues);
  }

  newStates[topicCode] = newState;

  return updateObject(oldState, { subscriptionStates: newStates });
}

const topicSubscriptionReducer = (state: TopicSubscriptionsState = initialState, action: any) => {
  switch (action.type) {
    case TopicSubscriptionActionType.TOPIC_SUBSCRIPTION_LOADED: {
      return updateSubscriptionState(action.payload.topicCode, state, {
        topicName: action.payload.topicName,
        isSubscribed: action.payload.isSubscribed,
        loadingState: createLoadingState(false, false, true)
      });
    }
    case TopicSubscriptionActionType.TOPIC_SUBSCRIPTION_SET_LOADING: {
      return updateSubscriptionState(action.payload.topicCode, state, {
        topicName: null,
        isSubscribed: null,
        loadingState: createLoadingState(false, true, false)
      });
    }
    case TopicSubscriptionActionType.TOPIC_SUBSCRIPTION_UNLOAD: {
      return updateSubscriptionState(action.payload.topicCode, state, {
        topicName: null,
        isSubscribed: null,
        loadingState: createLoadingState(false, false, false)
      });
    }
    case TopicSubscriptionActionType.TOPIC_SUBSCRIPTION_SET_ERRORED: {
      return updateSubscriptionState(action.payload.topicCode, state, {
        topicName: null,
        isSubscribed: null,
        loadingState: createLoadingState(true, false, false),
        loadingError: {
          errorCode: action.payload.errorCode,
          errorDescription: action.payload.errorDescription,
          errorResult: action.payload.errorResult
        } as ResponseError
      });
    }
    default:
      return state;
  }
};

export default topicSubscriptionReducer;
